import React from 'react'

const styles = {
    spanTag: 'text-lyellow font-semibold'
}

const About = () => {
  return (
    <>
        <div className="flex items-center">
        <div className="text-white">
          <h2 className="text-2xl sm:text-3xl font-semibold">About <span className="text-lyellow">Give A Bag</span></h2>
          <p className="mt-3 gap-y-2 text-lg"><span className="font-semibold">Launched on 1 July, 2022, <span className="text-lyellow">Grab A Bag</span></span> is a first ever <span className={styles.spanTag}>Ticket Buying Technology</span> that allows lottery to be bought in USDT and win in USDT.&nbsp;It does not get simpler than this.&nbsp;There are <span className={styles.spanTag}>Daily</span> and <span className={styles.spanTag}>Weekly</span>&nbsp;draws through which a chunk of the <span className={styles.spanTag}>Jackpot</span> can be won.&nbsp;<span className={styles.spanTag}>Grab A Bag</span>&nbsp;uses a sophisticated<span className={styles.spanTag}>&nbsp;Balloting System</span>&nbsp;that determines the winning number.</p>
        </div>
      </div>

      
    </>
  )
}

export default About